// extracted by mini-css-extract-plugin
module.exports = {"privateRoutePlaceholder":"PrivateRoute_privateRoutePlaceholder__1k68U"};